/**
 * Created by vladislav on 7/14/2025
 */

const MultiplayerRequests = function () {
    ConnectorEventEmitter.call(this);
};

MultiplayerRequests.prototype = Object.create(ConnectorEventEmitter.prototype);
MultiplayerRequests.prototype.constructor = MultiplayerRequests;

MultiplayerRequests.prototype.send = function (fromUserId, toUserId, type, callback = () => {}) {
    const projectId = connector.config.projectId;
    fromUserId = encodeURIComponent(fromUserId);
    ConnectorRestClient.post(`${connector.config.multiApiURL}/requests/${projectId}/${fromUserId}`, {
        toUserId,
        type
    }, (success) => {
        if (!success) {
            this.trigger("error:send", "request_already_sent", type);
        }

        callback(Boolean(success));
    }, (error) => {
        this.trigger("error:send", `api_error_${error.status}_${error.errorMessage}`, type);

        callback(false);
    });
};

MultiplayerRequests.prototype.get = function (callback = () => {}) {
    const projectId = connector.config.projectId;
    const userId = encodeURIComponent(connector.platform.getUserID());
    ConnectorRestClient.get(`${connector.config.multiApiURL}/requests/${projectId}/${userId}`, {}, (data) => {
        callback(data);
    }, () => {
        callback();
    });
};

MultiplayerRequests.prototype.delete = function (requestId, callback = () => {}) {
    ConnectorRestClient.delete(`${connector.config.multiApiURL}/requests/${requestId}`, {}, (success) => {
        callback(Boolean(success));
    }, () => {
        callback(false);
    });
};
